export default () => {

	const btns = document.querySelectorAll('[href="#live-chat"]');
	if (!btns.length) return;

	btns.forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();

			const chatIframe = document.querySelector('#dummy-chat-button-iframe');
			if (!chatIframe) return;

			chatIframe.style.display = 'block';

		});
	});

}